/**
 * One source of truth for report names + explainers. The nav dropdown and
 * each report page header both read from here, so the copy can never drift.
 * Order here = tab order on /reports.
 */
export interface ReportMeta {
  slug: string;
  label: string;
  description: string;
}

export const REPORT_META: ReportMeta[] = [
  {
    slug: "library",
    label: "Report home",
    description:
      "Start here - quick answers to common questions, plus ready-made dashboards you can install in one click.",
  },
  {
    slug: "scorecard",
    label: "Scorecard",
    description:
      "Your key funnel numbers for one month, compared against the month before - the health check you read top to bottom.",
  },
  {
    slug: "attribution",
    label: "Attribution",
    description:
      "Which channels, sources, and campaigns actually created pipeline and closed revenue - credited by the model you choose.",
  },
  {
    slug: "web",
    label: "Web & Ads",
    description:
      "Traffic, search queries, and ad performance from your connected Google and LinkedIn accounts, next to your CRM outcomes.",
  },
  {
    slug: "builder",
    label: "Report builder",
    description:
      "Build a custom report from any object and field, then save it to a dashboard on your home screen.",
  },
];

export const reportMeta = (slug: string): ReportMeta =>
  REPORT_META.find((r) => r.slug === slug) ?? REPORT_META[0]!;
